module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_6.e5bfb2d6.png";